import { Component, AfterViewInit,ViewChild, OnInit, ɵConsole } from '@angular/core';
import { MessageclientService } from '../../../../service/messageclient.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Platform,IonItemSliding } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { DatePipe } from '@angular/common';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from "../../../../bizlogic/servicesbll";
import { GridBaseCase } from '../../grid/grid.base.case';
import { Device } from '@ionic-native/device/ngx';//获取手机硬件设备
import { CommonService } from 'src/service/common.service';
declare var app;

@Component({
  selector: 'app-mz-scheduling',
  templateUrl: './mz-scheduling.component.html',
  styleUrls: ['./mz-scheduling.component.scss']
})
export class MzSchedulingComponent extends GridBaseCase implements AfterViewInit, OnInit {
  ch: any;//日历汉化配置
  data:Date;
  Today = {
    day: null,
    month: null,
    year: null
  };
  detailList:Array<any> =[];//明细列表
  isCheckOldDate = false;//是否选中过去的日子
  checkDate: any = new Date();//选中的日期
  checkDatePlan = false;//选中的日期是否存在计划
  deleteSchedule:boolean = false;//删除排班
  /**
   * 所有日程
   */
  scheduleDate = [];
  scheduleDateString = "";

  searchDate: any = null;//每次获取列表查询日期
  initGetData:boolean = true;
  /** 
   * 当前选中日程
  */
  currentSchedule = [];
  @ViewChild(IonItemSliding) itemSliding: IonItemSliding;
  tabsIndex = 0;//选中tabs
  schedulingSummaryObj:any = {};//排班统计信息
  isAndroid4:boolean = false;//是否是安卓4以下
  isAndroid5Down:boolean = false;//是否是安卓5以下
  isAndroid5:boolean = false;//是否是安卓5
  constructor(
    private msg: MessageclientService,
    private activaRouter: ActivatedRoute,
    private platform: Platform,
    private http: HttpCustomerService,
    private router: Router,
    private device:Device,
    public com: CommonService
  ) {
    super();
    const d = new Date();
    this.Today.year = d.getFullYear();
    this.Today.month = d.getMonth();
    this.Today.day = d.getDate();
    this.ch = {
      /** 每周第一天，0代表周日 */
      firstDayOfWeek: 0,
      /** 每周天数正常样式 */
      dayNames: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      /** 每周天数短样式（位置较小时显示） */
      dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      /** 每周天数最小样式 */
      dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
      /** 每月月份正常样式 */
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      /**每月月份短样式 */
      monthNamesShort: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      today: '今天',
      clear: '清除'
    };
  }

  ngAfterViewInit() {
    const that = this;
    let date = {
      year: that.Today.year,
      month: that.Today.month + 1
    }
    // that.getSearchDate(date);
    that.timeOutSearchDate(date);
    if(that.platform.is("cordova")){
      if(that.platform.is("android")){
        if(that.device.version){//版本号存在
          if(that.device.version.toString().startsWith("5")){//当前版本小于等于5.0
            that.isAndroid5 = true;//等于5
            that.isAndroid5Down = true;
            that.isAndroid4 = false;
          }else if(that.device.version.toString().startsWith("4")){//当前版本小于等于4.0
            that.isAndroid5Down = true;//小于5.0
            that.isAndroid4 = true;
          }else if(that.device.version.toString().startsWith("3")){//当前版本小于等于3.0
            that.isAndroid5Down = true;//小于5.0
            that.isAndroid4 = true;
          }
        }
      }
    }



   
  }
  ngOnInit() {
    // const that = this;
    // that.getScheduleList();
   
  }

  /**
   * 
   * @param num 选中
   */
  tabsEvent(num){
    const that =this;
    this.tabsIndex = num;
    if(num==2){
      that.binddetailinfo();
    }
  }

  /**
   * 获取日程列表
   */
  getScheduleList(loads) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const type = that.activaRouter.snapshot.paramMap.get('type');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    if(id){
      id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    }
    let body = new WebParameterContext();

    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = PageName;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let _id = that.com.GetAccount.Id;
    if(type == "view"){
      _id = id;
    }
    body.RequestBody = JSON.stringify({ "a_SNStartDate": that.searchDate, "a_FK_SystemUser_ID": _id });
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      loads.dismiss();
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }

      
      that.http.post(app.DEFAULTURL, body).then(data => {
        loads.dismiss();
        data = HandleServerContextAfterDBRequest(body, data);
        that.scheduleDate = [];
        if (data.ResponseMessage.Success) {
          // that.scheduleDate = data.Status.Datas;
          if(data.Status.Datas){
            data.Status.Datas.forEach(function (item) {
              let objfield = {};
              that.element.selectItemList.selectItem.forEach((element, index) => {
                if (element.bindingField) {
                  objfield[element.bindingField] = item[element.field];
                }
              });
              that.scheduleDate.push(objfield);
            });
          }
          if(that.initGetData || that.deleteSchedule){
            that.initGetData = false;
            that.deleteSchedule = false;
            that.DateSelect(that.checkDate);
          }
          that.schedulingSummary();//统计信息；
        }
      }).catch(error => {
        console.log(error);
        loads.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
        // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
        //   //that.router.navigate(["/login"]);
        // })
      })

    
  }

  //删除临时计划
  deleteData(item) {
    const that = this;
    that.msg.Confirm('确认删除？').then(data => {
      if (data) {
        that.itemSliding.closeOpened();
        const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
        let body = new WebParameterContext();

        if (that.element.selectItemList.gridViewConfigName) {
          body.ConfigName = that.element.selectItemList.gridViewConfigName;
        } else if (that.ConfigName) {
          body.ConfigName = that.ConfigName;
        }
        body.OpType = "delete";
        body.ConfigType = "form";
        body.Client.PageName = PageName;
        body.Client.ApiType = "Element";
        body.Client.Name = PageName;
        body.Client.ClientType = 2;
        if (that.platform.is("android")) {
          body.Client.ClientType = 0;
        } else if (that.platform.is("ios")) {
          body.Client.ClientType = 1;
        }

        body.RequestBody = JSON.stringify({ "a_ID": item.ID });
        body = HandleWebParameterContextBeforeDBRequest(body);
        if (!body.ResponseMessage.Success) {
          that.msg.Alert(body.ResponseMessage.ErrorMessage);
          return;
        }
        that.msg.Loading("数据加载中...").then(loads=>{
          that.http.post(app.DEFAULTURL, body).then(data => {
            data = HandleServerContextAfterDBRequest(body, data);
            loads.dismiss;
            if (data.ResponseMessage.Success) {
              setTimeout(()=>{
                that.getScheduleList(loads);
              },100);
              that.deleteSchedule = true;
            }
          }).catch(error => {
            console.log(error);
            loads.dismiss;
            that.msg.Alert(error.ResponseMessage.ErrorMessage);
            // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
            //   //that.router.navigate(["/login"]);
            // })
          })
          loads.present();
        })
        
      }
    })

  }
  /**
* 下拉刷新数据
* @param event
*/
  //  doRefresh(event) {
  //   this.getScheduleList();
  //   event.target.complete();
  // }



  /**
   * 获取当天日程
   */
  getCurrentSchedule(day) {
    let that = this;
    that.currentSchedule = [];
    let d = this.DateFormat(day);
    this.scheduleDate.forEach(function (item, i) {
      console.log(item,"******************")
      if (item.date && item.date.indexOf(d) > -1) {
        if(item.beginDate){
          item.beginDate = item.beginDate.replace(/-/g, "/");
        }
        if(item.endDate){
          item.endDate = item.endDate.replace(/-/g, "/");
        }
        if(item.schedulingMethod == 1 || item.schedulingMethod == "1" ){
          item.typeName ="临时排班";
        }
        that.currentSchedule.push(item);
      }
    })
  }


  /**
   * 选中日期
   * @param ev 
   * @param d 
   */
  DateSelect(d) {
    let that = this;
    // debugger;
    that.checkDate = d ;
    that.getCurrentSchedule(that.checkDate);
    console.log(  that.getCurrentSchedule(that.checkDate))
    console.log(that.checkDate)
    console.log(typeof(that.checkDate),"选中的值")
    const d1 = new Date(d.toString().replace(/-/g, "/"));
    let checkDay = {};
    checkDay['year'] = d1.getFullYear();
    checkDay['month'] = d1.getMonth();
    checkDay['day'] = d1.getDate();
    that.isCheckOldDate = that.isOldDate(checkDay);
    that.checkDatePlan = that.getSchedule(checkDay);//当前选中日期是否存在
    // this.msg.Show(ev.getDate());
    let monthDom = document.getElementsByClassName("ui-datepicker-month");
    let cMonth = checkDay['month'];
    if(monthDom.length > 0){
      cMonth = monthDom[monthDom.length-1]['innerText'].replace('月', '');
    }
    
    if ((d1.getMonth() + 1) != parseInt(cMonth)) {
      that.currentSchedule = [];//清除选中天的排班计划
      let date = {
        year: d1.getFullYear(),
        month: d1.getMonth() + 1
      }
      // setTimeout(()=>{
      //   that.getSearchDate(date);
      // },200);
      that.timeOutSearchDate(date);
      that.initGetData = true;
    }
    // const beforeDate = new Date(that.searchDate['BeforeValue'].replace(/-/g, "/")).getMonth;
    // if(that.searchDate['BeforeValue'] > that.currentMonth){

    // }

  }
  EventBind(item){
    const that=this;
    console.log(item);
   let id = that.activaRouter.snapshot.paramMap.get('id');
   let type = that.activaRouter.snapshot.paramMap.get('type');
   if(id){
     id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
     if(type!="add"){
       if(id.indexOf("-")==-1){
        id= that.com.GetAccount.Id;
       }
      localStorage.setItem("fscheduleId",id);//缓存当前登录人
     }
   }
   let datepipe =new DatePipe("en-US");
    // let datepipetime= datepipe.transform(that.checkDate.toString.replace(/-/g, "/"),"yyyy/MM/dd");
  //  let datetimeouts:any;
   console.log(typeof(that.checkDate))
  //  if(typeof(that.checkDate) != "object"){
    let datetimeouts = datepipe.transform(that.checkDate.toString().replace(/-/g, "/"),"yyyy/MM/dd");
 
    const d1 = new Date(datetimeouts.replace(/-/g, "/"));//获取当前选中的日期日期
     let d=new Date();
   const d2 = new Date(d.toString().replace(/-/g, "/"));
      let d3 =  new Date(datepipe.transform(d2,"yyyy/MM/dd"));
   if(d1.getTime()>=d3.getTime()){//当前选择的日期大于当前日期才可以编辑
    if(d1.getTime()==d3.getTime()){
      if(item.typeName.indexOf("临时")>=0){
        that.msg.Alert("当天临时排班不可修改");
        return;
      }
    }
    // console.log(d1);
    if(that.checkDate){
      localStorage.setItem('scheduleDate', this.DateFormat(that.checkDate));
      // if(item.state!=1){
      //   this.com.setHistoryUrl();
      //   this.router.navigate(["/tabs/contact/ScheduleMakingForm/edite/"+item.ID+"&"+this.com.getNowDatetime]);
      // }else{
      //   this.msg.Alert("已审批通过，不可修改");
      // }
      this.com.setHistoryUrl();
      // this.router.navigate(["/tabs/contact/ScheduleMakingForm/edite/"+item.ID+"&"+this.com.getNowDatetime]);
      this.com.Go("/tabs/contact/ScheduleMakingForm/edite/"+item.ID+"&"+this.com.getNowDatetime);
    }else{
      this.msg.Alert('请选择日期');
    }
  }else{
    that.msg.Alert("当天之前的排班不可修改");
  }
// }else{
//   this.msg.Alert('请选择日期');
// }
   
  }
  /**
   * 明细排班修改
   * @param item 选择当前的对象
   */
  EventClickInfo(item){
      const that=this;
      console.log(item);
      // debugger;
    let id = this.activaRouter.snapshot.paramMap.get('id');
    let type = this.activaRouter.snapshot.paramMap.get('type');
    if(id){
      id = this.activaRouter.snapshot.paramMap.get('id').split("&")[0];
      if(type!="add"){
        if(id.indexOf("-")==-1){
          id= this.com.GetAccount.Id;
        }
        localStorage.setItem("fscheduleId",id);//缓存当前登录人
      }
    }
    let datepipe =new DatePipe("en-US");
    let datetimeouts = datepipe.transform(item.a_SNStartDate.toString().replace(/-/g, "/"),"yyyy/MM/dd");
     const d1 = new Date(datetimeouts.toString().replace(/-/g, "/"));//获取当前选中的日期日期
      let d=new Date();
    const d2 = new Date(d.toString().replace(/-/g, "/"));
       let d3 =  new Date(datepipe.transform(d2,"yyyy/MM/dd"));
    if(d1.getTime()>=d3.getTime()){//当前选择的日期大于当前日期才可以编辑
      if(d1.getTime()==d3.getTime()){
        if(item.b_TypeName.indexOf("临时")>=0){
          that.msg.Alert("当天临时排班不可修改");
          return;
        }
      }
      if(this.checkDate){
        localStorage.setItem('scheduleDate', this.DateFormat(item.a_SNStartDate));
        this.com.setHistoryUrl();
        // this.router.navigate(["/tabs/contact/ScheduleMakingForm/edite/"+item.a_ID+"&"+this.com.getNowDatetime]);
        this.com.Go("/tabs/contact/ScheduleMakingForm/edite/"+item.a_ID+"&"+this.com.getNowDatetime);
      }else{
        this.msg.Alert('请选择日期');
      }
    }else{
      that.msg.Alert("当天之前的排班不可修改");
    }
  }

  /**
   * 判断日期是否存在
   * @param day 
   */
  getSchedule(date) {
    let date1 = '';
    if (!date.year) { return false; } else {
      date1 = date.year + '-' + ((date.month + 1) < 10 ? '0' + (date.month + 1) : (date.month + 1)) + '-' + (date.day < 10 ? '0' + date.day : date.day);
    }
    let isSchedule = false;
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(date1) > -1) {
        isSchedule = true;
      }
    })
    return isSchedule;
  }

  /**
   * 是否是过去的日期
   * @param date 
   */
  isOldDate(date) {

    if (date) {
      if (date.year < this.Today.year) {
        return true;
      } else if (date.year == this.Today.year) {
        if (date.month < this.Today.month) {
          return true;
        } else if (date.month == this.Today.month) {
          if (date.day < this.Today.day) {
            return true;
          }
        }
      }
    }
  }

  /**
   * 查看日程详情
   * @param item 选中的日程
   */
  // scheduleDetail(item) {
  //   this.router.navigateByUrl("/tabs/contact/CalendarForm/view/" + item['id']);
  // }

  addPlan() {
    if(this.checkDate){
      this.com.setHistoryUrl();
      localStorage.setItem('scheduleDate', this.DateFormat(this.checkDate));
      const type = this.activaRouter.snapshot.paramMap.get('type');
      if(type == "view"){
        const id = this.activaRouter.snapshot.paramMap.get('id').split("&")[0];
        localStorage.setItem('scheduleId', id);
      }else{
        localStorage.removeItem('scheduleId');
      }
      // this.router.navigateByUrl("/tabs/contact/ScheduleMakingForm/add/"+this.com.getNowDatetime);
      this.com.Go("/tabs/contact/ScheduleMakingForm/add/"+this.com.getNowDatetime);
      
    }else{
      this.msg.Alert('请选择日期');
    }
  }
  // 批量排版跳转页面
  addMore(){
    this.com.setHistoryUrl();
    // this.router.navigateByUrl("/tabs/contact/AddSchedule/plan/"+this.com.getNowDatetime);
    this.com.Go("/tabs/contact/AddSchedule/plan/"+this.com.getNowDatetime);
  }
  // 复制上周
  copyWeek(){
    this.placeCppyBind("week");
  }
  // 复制上月
  copymonth(){
    this.placeCppyBind("month");
  }
  placeCppyBind(type:any){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName = "CopyWeekScheduleNormal";
    if(type=="month"){
      body.ConfigName = "CopyMonthScheduleNormal";
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    that.msg.Loading("加载中，请稍后...").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        load.dismiss();
        if (data.ResponseMessage.Success) {
          this.com.setHistoryUrl();
           this.com.Go("/tabs/contact/approvalistmanagement/plan/week&"+this.com.getNowDatetime);
          if(type=="month"){
            this.com.Go("/tabs/contact/approvalistmanagement/plan/month&"+this.com.getNowDatetime);
          }
        }else{
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        load.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      });
      load.present();
    })
  }
  /**
   * 格式化日期
   * @param date 日期
   */
  DateFormat(dateFormat) {
    let date = dateFormat;
    if (date) {
      date = new Date(date.toString().replace(/-/g, "/"));
    } else {
      return;
    }
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    if (m < 10) {
      m = '0' + m;
    }
    let d = date.getDate();
    if (d < 10) {
      d = '0' + d;
    }
    return y + '-' + m + '-' + d;
  }


  /**
   * 月份改变
   * @param event 
   */
  monthChange($event) {

    const that = this;
    that.checkDate = null;
    that.currentSchedule = [];////清除选中天的排班计划
    // setTimeout(() => {
    //   that.getSearchDate($event);
    // },200);
    that.timeOutSearchDate($event);
  }

  /**
   * 设置月份查询条件
   * @param date 
   */
  getSearchDate(date,loads) {
    const that = this;
    const d = date;
    let timerI = 0;
    let timer = setInterval(()=>{
      let domList:any = document.getElementsByClassName("ui-datepicker-calendar");
      timerI++;
      if(domList.length == 0){
        if(timerI < 10){
          return;
        }else{
          clearInterval(timer);
        }
      }else{
        clearInterval(timer);
      }
      
      let dom = null;
      const l = domList.length;
      if(l > 0){
        dom = domList[l-1];
      }else{}
      
      let timerI2 = 0;
      let timer2 = setInterval(()=>{
        const beginEle = dom.children[1].children[0].children[0]; 
        const endEle = dom.children[1].lastElementChild.lastElementChild;
        timerI2++;
        if(!beginEle && !endEle){
          if(timerI2 < 10){
            return;
          }else{
            clearInterval(timer2);
          }
        }else{
          clearInterval(timer2);
        }
        const beginDay = beginEle.children[0].children[0]['innerText'].replace(/(^\s*)|(\n*)|(\s*$)/g, "");
        const endDay = endEle.children[0].children[0]['innerText'].replace(/(^\s*)|(\n*)|(\s*$)/g, "");
        let beginMonth = beginEle.getAttribute("class").indexOf("ui-datepicker-other-month") >= 0 ? (d.month - 1) : (d.month);
        let endMonth = endEle.getAttribute("class").indexOf("ui-datepicker-other-month") >= 0 ? (d.month + 1) : (d.month);
        let beginYear = d.year;
        let endYear = d.year;
        if (beginMonth == 0) {
          beginMonth = 12;
          beginYear = d.year - 1;
        } else if (endMonth == 13) {
          endMonth = 1;
          endYear = d.year + 1;
        }
    
        const beginDate = beginYear + '-' + beginMonth + '-' + beginDay + ' 00:00:00';
        const endDate = endYear + '-' + endMonth + '-' + endDay + ' 23:59:59';
        this.searchDate = that.com.BetweenDate(beginDate, endDate);
        that.getScheduleList(loads);
      },400);
    },400);
  }

  timeOutSearchDate(date){
    const that = this;
    that.msg.Loading("数据加载中...").then(loads=>{
      setTimeout(() => {
        that.getSearchDate(date,loads);
      },200);
      loads.present();
    })
  }

  /**
   * 工作类型
   * @param date 
   */
  getWorkState(date){
    let that = this;
    let text='';
    let date1 = '';
    if (!date.year) 
    { return text;  }
     else {
      date1 = date.year + '-' + ((date.month + 1)<10? '0'+ (date.month + 1):(date.month + 1)) + '-' + (date.day < 10? '0'+date.day:date.day);
    }

    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(date1) > -1) {
        if(item.schedulingMethod == 1 || item.schedulingMethod == "1" ){
          item.ShortName ="临";
        }
         text= that.getWorkStateText(item);
        }
      })
      return text;
  }

  getWorkStateText(item) {
    // let value=item.type;
    //已拒绝的不显示
    let value = item.ShortName;
    if(item&&item.state!=2){
      return value;
    // switch (value)
    // {
    //   case "T001":
    //       return "早";
    //   case "T002":
    //       return "中";
    //   case "T003":
    //     return "晚";
    //   case "T004":
    //       return "全";
    //   case "T005":
    //     return "年";
    //   case "T006":
    //     return "病";
    //   case "T007":
    //     return "休";
    //   case "T008":
    //     return "临";
    //   case "T009":
    //     return "其";
    // }
    
  }
  }

  /**
   * 排班统计
   * @param  
   */
  schedulingSummary(){
    // debugger;
    let monthDom = document.getElementsByClassName("ui-datepicker-month");
    let yearDom = document.getElementsByClassName("ui-datepicker-year");
    let m = null;
    let y = null;
    if(yearDom.length > 0){
      y = yearDom[yearDom.length-1]['innerText'].replace('年', '');
    }
    if(monthDom.length > 0){
      m = monthDom[monthDom.length-1]['innerText'].replace('月', '');
      m = m < 10 ? "0"+m : m;
    }
    const date = y + "-" + m;
    let currentMonthData = [];
    let workType1 = [];//上班天數
    let workType2 = [];//休息天数
    let workType3 = [];//请假天数
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(date) > -1) {
        currentMonthData.push(item);
        if(item.type == "T001" || item.type == "T002" || item.type == "T003" || item.type == "T004" || item.type == "T008"|| item.type == "T010"|| item.type == "T011"){
          workType1.push(item);
        }else if(item.type == "T007" || item.type == "T012"){
          workType2.push(item);
        }else if(item.type == "T005" || item.type == "T006"){
          workType3.push(item);
        }
      }
    })

    const _currentMonthDays = new Date(y,m,0).getDate();
    this.schedulingSummaryObj = {
      monthDays:_currentMonthDays,
      total:currentMonthData.length,
      workType1:workType1.length,
      workType2:workType2.length,
      workType3:workType3.length,
      noWorkDays:_currentMonthDays - currentMonthData.length
    }

  }
  binddetailinfo(){
    const that = this;
    that.detailList=[];
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const type = that.activaRouter.snapshot.paramMap.get('type');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "TBScheduleNormalXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = PageName;
    body.Client.ClientType = 2;
    let _id = that.com.GetAccount.Id;
    body.RequestBody = JSON.stringify({ "a_SNStartDate": that.com.BetweenDate(that.com.getNow+" 00:00:00", "2090-12-12 23:59:59"), "a_FK_SystemUser_ID": _id });
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
          // debugger;
          data.Status.Datas.forEach(item=>{
            item.a_SNStartDate=item.a_SNStartDate.replace(/-/g, "/");
            item.a_SNEndDate=item.a_SNEndDate.replace(/-/g, "/");
            if(item.a_SchedulingMethod == 1 || item.a_SchedulingMethod == "1" ){
              item.b_TypeName ="临时排班";
            }
          });
          console.log()
          that.detailList=data.Status.Datas;
        }
      }).catch(error => {
        console.log(error);
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
        // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
        //   //that.router.navigate(["/login"]);
        // })
      })
  }

}




